import moment from "moment"
import "./styles.scss"
import { useEffect, useState } from "react"

const formatDateToDDMM = (item) => {
  let dateTime = new Date(item)
  return moment(dateTime).format("DD/MM")
}
const formatDateToHHmm = (item) => {
  let dateTime = new Date(item)
  return moment(dateTime).format("HH:mm")
}

const ScheduledEvents = ({ items, setCurrentDateOnClick, handleEventClick, calendarRef }) => {
  const [date, setDate] = useState(new Date())

  useEffect(() => {
    setCurrentDateOnClick && setCurrentDateOnClick(date)
  }, [date])

  const gotoDate = (value) => {
    setDate(value)
    calendarRef.current.getApi().gotoDate(new Date(value))
  }

  return (
    <div className="sheduled-events">
      <h2>Eventos Programados</h2>
      <ul className="sheduled-events-list">
        {items?.length > 0 &&
          items.map((item, index) => (
            <li
              className="sheduled-events-list__item"
              key={index}
              onClick={() => gotoDate(item.start)}>
              <div className="sheduled-events-list__item-date-time">
              <div
                className={`sheduled-events-list__item-date ${
                  formatDateToDDMM(item.start) !== formatDateToDDMM(item.end) || !item.end.includes("0000-00-00") && "min-font"
                }`}
                style={{ backgroundColor: item.color }}>{`${
                formatDateToDDMM(item.end) === formatDateToDDMM(item.start) || item.end.includes("0000-00-00")
                  ? moment(item.start).format("DD")
                  : formatDateToDDMM(item.start) + " " + formatDateToDDMM(item.end)
              }`}</div>
              
              </div>
              <div className="sheduled-events-list__item-details">
                <div className="event-info">
                <div className="event-time">
                  {formatDateToHHmm(item.start) === formatDateToHHmm(item.end) || item.end.includes("0000-00-00")
                    ? formatDateToHHmm(item.start)
                    : formatDateToHHmm(item.start) + " às " + formatDateToHHmm(item.end)}
                </div>
                  <span className="event-name">{item.title}</span>
                  <span className="event-desc">{item.description}</span>
                  
                </div>
              </div>
            </li>
          ))}
      </ul>
    </div>
  )
}

export default ScheduledEvents
